import { SnackbarContext } from '@/contexts/SnackbarContext';
import { useContext } from 'react';

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar deve ser utilizado SnackbarProvider');
  }
  return context;
};
